var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    staticClass: "input-with-select",
    class: { "input-with-select--open": _vm.focused },
    attrs: { placeholder: _vm.placeholder },
    on: {
      blur: function($event) {
        return _vm.$emit("blur")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "append",
        fn: function() {
          return [
            _c(
              "el-select",
              {
                on: {
                  "visible-change": function($event) {
                    _vm.focused = !_vm.focused
                  }
                },
                model: {
                  value: _vm.select,
                  callback: function($$v) {
                    _vm.select = $$v
                  },
                  expression: "select"
                }
              },
              _vm._l(_vm.options, function(option) {
                return _c("el-option", {
                  key: option.value,
                  attrs: { label: option.label, value: option.value }
                })
              }),
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.input,
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }